import e from"react";import l from"prop-types";import t,{css as r}from"styled-components";import{calculateRem as i}from"@vds-core/utilities";import{ColorTokens as o}from"@vds-tokens/color";import{Fonts as a}from"@vds-core/typography";import{TypographyTokens as n}from"@vds-tokens/typography";const d={fillColor:l.oneOf(["red","yellow","green","orange","blue","black","white"]),surface:l.oneOf(["light","dark"]),numberOfLines:l.number,maxWidth:l.string,children:l.string,id:l.string},u={green:{light:o.palette.green26.value,dark:o.palette.green36.value},orange:{light:o.palette.orange41.value,dark:o.palette.orange58.value},blue:{light:o.palette.blue38.value,dark:o.palette.blue46.value}},p={red:o.background.brandhighlight.value,yellow:o.palette.yellow53.value,black:o.palette.black.value,white:o.palette.white.value},s=t.div.withConfig({displayName:"StyledBadge",componentId:"VDS__sc-vb6h7b-0"})`
  display: inline-block;
  text-overflow: ellipsis;
  background-color: ${({fillColor:e})=>e};
  color: ${({textColor:e})=>e};
  border-radius: 2px;
  font-family: ${a.VerizonNHGeTX};
  font-size: ${i(n.fontsize.body[12].value)};
  font-weight: ${n.fontweight.bold.value};
  line-height: ${i(n.lineheight.body[16].value)};
  width: auto;
  height: auto;
  min-width: 23px;
  max-width: ${({maxWidth:e})=>e};
  padding: 2px 4px;
  box-sizing: border-box;
  > div {
    ${({maxWidth:e})=>e?r`
            margin: 0;
            display: -webkit-box;
            -webkit-line-clamp: ${({numberOfLines:e})=>e};
            -webkit-box-orient: vertical;
            overflow: hidden;
          `:r`
            margin: 0;
          `}
  }
`,g=l=>{const{children:t,fillColor:r,surface:i,numberOfLines:a,maxWidth:n,id:d}=l;return e.createElement(s,{fillColor:["green","orange","blue"].includes(r)?u[r][i]:p[r],textColor:(()=>{switch(i){case"light":return["red","green","orange","blue","black"].includes(r)?o.palette.white.value:o.palette.black.value;case"dark":return["red","black"].includes(r)?o.palette.white.value:o.palette.black.value}})(),surface:i,numberOfLines:a,maxWidth:n,id:d},e.createElement("div",null,t))};g.propTypes=d,g.defaultProps={fillColor:"red",surface:"light"};export{g as default};
